// The brand's colours, as raw hex, in ONE place.
//
// WHY A MODULE AND NOT THE THEME: three of the four consumers cannot see a theme. `carto2-box.ts`
// builds tooltip html that deck.gl injects with innerHTML, outside React; `status-icons.ts` builds
// marker SVGs as data-URIs; the deck.gl layers want a hex, not a token. Only the fourth, the MUI
// theme, could read a token — so the theme imports FROM here instead of the other way round, and a
// raw hex exists exactly once.
//
// WHAT IS NOT HERE, on purpose: the five traffic-light colours. Green, yellow, orange, red and
// black arrive from the catalogue (`seed_relacion_status_codigos.value`, through `code_types`), so
// they are DATA and the warehouse owns them. Copying them here would create a second source that
// silently stops matching the day a seed changes. `INVALID_GREY` is not one of them: it means "no
// verdict", which is our word for the absence of a status, not a status the catalogue can send.

/**
 * Consorcio's corporate blue, and its hover shade. Both are the values the design file DECLARES
 * (`consorcio_seguros.sketch`: "Primary #003DA6" and "Accent hover #002b74"; 41 of its text layers
 * are #003DA6 and none is anything else).
 *
 * It used to be #003aa9 in the theme, sampled off a PNG of carto2's wordmark with canvas —
 * antialiased glyph pixels, three units off in G and B from the hex the design states and from the
 * one the tooltip box had been using all along, so the app painted the same blue heading two
 * different ways. That is the drift this module exists to make impossible.
 */
export const CONSORCIO_BLUE = '#003DA6'
export const CONSORCIO_BLUE_HOVER = '#002b74'

/** Body text on the carto2-style surfaces: the tooltip box and the result box. */
export const INK = '#383d4c'

/** Secondary text and chrome: the box's subtitle, the preview marker's ring. */
export const SLATE = '#626775'

/**
 * "No verdict": the point has no status to show. It is the marker's fill for an invalid result and
 * the fallback `normHex` falls back TO when the catalogue's colour is missing or malformed.
 */
export const INVALID_GREY = '#969696'
